import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/lib/Async';
import Select, { components } from 'react-select';
import styled from 'styled-components';
import { inputBorderColor } from 'Styles/helpers';
import { rem, rgba } from 'polished';
import Label from '../label';
import HelperText from '../helper-text';
import apiData from '../../../lib/apiData';

export default class GullSelect extends PureComponent {

  handleChange = (value) => {
    // this is going to call setFieldValue and manually update values.topcis
    this.props.onChange(this.props.valueName, value);
  };

  handleBlur = () => {
    // this is going to call setFieldTouched and manually update touched.topcis
    if (this.props.onBlur) {
      this.props.onBlur(this.props.valueName, true);
    }
  };

  formatOptions = items => (
    items.map(item => ({

      label: item.title || `${item.firstName} ${item.lastName} (${item.email})`,
      value: item.id,
      ...(item.merchantAccountId ? { merchantAccountId: item.merchantAccountToken } : {}),
      ...(item.merchantSettlementCurrency
        ? { settlementCurrency: item.merchantSettlementCurrency }
        : {}
      ),
    }))
  );

  fetchOptions = async (inputValue) => {
    const options = await apiData(`${this.props.dataEndpoint}&query=${inputValue}`);

    return this.formatOptions(options.items);
  }

  Input = props => <components.Input {...props} autoComplete="new-password" />

  render() {
    const { async } = this.props;

    return (
      <SelectWrap errors={this.props.errors} isDark={this.props.isDark}>

        {this.props.label &&
          <Label
            htmlFor={this.props.id}
            hideLabel={this.props.hideLabel}
          >
            {this.props.label}
          </Label>
        }

        {!async &&
          <Select
            components={{ Input: this.Input }}
            id={this.props.id}
            options={this.props.options}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={this.props.value}
            placeholder={`${this.props.placeholder}${this.props.required ? '*' : ''}`}
            isDisabled={this.props.isDisabled}
            openMenuOnFocus
            classNamePrefix="select"
            instanceId={`select-${this.props.id}`}
            isSearchable={this.props.isSearchable}
            blurInputOnSelect
          />
        }

        {async &&
          <AsyncSelect
            id={this.props.id}
            defaultOptions
            loadOptions={this.fetchOptions}
            options={this.props.options}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            value={this.props.value}
            placeholder={`${this.props.placeholder}${this.props.required ? '*' : ''}`}
            isDisabled={this.props.isDisabled}
            openMenuOnFocus
            classNamePrefix="select"
            instanceId={`select-${this.props.id}`}
            isSearchable={this.props.isSearchable}
            blurInputOnSelect
          />
        }

        {!!this.props.errors &&
        this.props.touched && (
          <HelperText>
            <HelperText.Error>{this.props.errors}</HelperText.Error>
          </HelperText>
        )}

      </SelectWrap>
    );
  }
}

const SelectWrap = styled.div`
  position: relative;
  padding-bottom: 2rem;

  .select__control,
  .select__menu,
  .select__input input {
    font-family: inherit;
    font-size: ${rem(16)};
    line-height: 1.5rem;
    text-align: left;
    color: ${props => props.theme.black};
    background-color: transparent;
  }

  .select__menu {
    max-width: 100%;
    z-index: 20;
    background-color: #fff;
  }

  .select__value-container {
    padding: 0;
  }

  .select__indicator.select__dropdown-indicator {
    padding-right: 0;
  }

  .select__control {
    padding: 2px 0;
    border: 0;
    border-bottom: 2px solid ${props => inputBorderColor(props)};
    border-radius: 0;

    &:hover { border-color: ${props => inputBorderColor(props)}; }
  }

  .select__indicator-separator {
    display: none;
  }

  .select__option--is-focused {
    background-color: ${props => props.theme.lightGray};
  }

  .select__option--is-selected,
  .select__option:active {
    color: #fff;
    background-color: ${props => props.theme.blue};
  }

  .select__control.select__control--is-focused {
    box-shadow: none;
    border-bottom: 2px solid ${props => props.theme.blue};
  }

  .select__control.select__control--is-disabled {
    background-color: transparent;
    opacity: .75;
    border-color: ${props => rgba(props.theme.black, 0.25)};
  }

  .select__single-value {
    color: ${props => props.isDark ? '#fff' : props.theme.black};
  }
`;
